import { graphql } from '../../../../graphql/generated';

export const CATALOG_PARAMETER_FORM_QUERY = graphql(`
  query CatalogParameterForm($labId: ID!) {
    insurances {
      id
      shortName
    }

    labSpecialRates(labId: $labId) {
      id
      name
      shortName
      code
    }

    labDiagnoses(labId: $labId) {
      id
      name
    }

    labSpecimens(labId: $labId) {
      id
      name
      classification
    }

    labForms(labId: $labId) {
      id
      name
    }

    labPeriodicGroups(labId: $labId) {
      id
      name
    }
  }
`);
